import cn from 'classnames';
import type { FC } from 'react';
import React from 'react';
import { useNamedContainersWithChildren } from '@alfa-bank/site-named-container/utils';

// TODO: при обновление core-components-button кнопка может стать черной, так как обновились токены
// вместе с кнопкой нужно апнуть пакет "@alfalab/core-components-themes": ~12.1.0 тогда кнопка остается красной при view=primary

import type { TProps } from './models';
import { DEPRECATED_BORDER_RADIUS, DESIGN_BORDER_RADIUS, DESIGN_CLICK_ANIMATION } from './config';

export const Button: FC<TProps> = ({
    CoreButton,
    block = false,
    borderRadius = DESIGN_BORDER_RADIUS,
    children,
    className,
    hasAnimation = DESIGN_CLICK_ANIMATION,
    innerClassName,
    loading = false,
    nowrap = false,
    size = 'm',
    styles,
    view = 'secondary',
    leftAddons,
    rightAddons,
    colors = 'default',
    textResizing,
    ...restProps
}) => {
    const {
        children: otherChildren,
        leftAddons: leftAddonsSlot,
        rightAddons: rightAddonsSlot,
    } = useNamedContainersWithChildren(children);

    const button = (
        <CoreButton
            block={block}
            className={cn(
                styles.external,
                {
                    /**
                     * TODO: Удалить после того, как все кнопки будет использовать радиус скругление 8px
                     */
                    [styles.deprecatedBorderRadius]: borderRadius === DEPRECATED_BORDER_RADIUS,
                    [styles.hasAnimation]: hasAnimation,
                },
                innerClassName
            )}
            colors={colors}
            leftAddons={leftAddonsSlot || leftAddons}
            loading={loading}
            nowrap={nowrap}
            rightAddons={rightAddonsSlot || rightAddons}
            size={size}
            textResizing={textResizing}
            view={view}
            {...restProps}
        >
            {/* Проверка необходима для поддержки iconOnly режима. useNamedContainersWithChildren трансформирует children в массив, а iconOnly режим активируется если значение children falsy */}
            {otherChildren.length > 0 && otherChildren}
        </CoreButton>
    );

    return className ? (
        <div className={cn({ [styles.container]: !block }, className)}>{button}</div>
    ) : (
        button
    );
};
